export default {
  'pages.businessAppMarket.title': 'アプリマーケット',
  'pages.businessAppMarket.subtitle':
    'チームに適した業務アプリを見つけ、必要に応じて利用を開始できます。',
  'pages.businessAppMarket.backToCenter': 'アプリに戻る',
  'pages.businessAppMarket.myApps': 'マイアプリ',
  'pages.businessAppMarket.refresh': '更新',
  'pages.businessAppMarket.searchLabel': 'アプリ名',
  'pages.businessAppMarket.searchPlaceholder': 'アプリ名や説明を検索',
  'pages.businessAppMarket.search': '検索',
  'pages.businessAppMarket.pricingLabel': '料金種別',
  'pages.businessAppMarket.all': 'すべて',
  'pages.businessAppMarket.free': '無料',
  'pages.businessAppMarket.paid': '有料',
  'pages.businessAppMarket.categoryLabel': 'カテゴリ',
  'pages.businessAppMarket.allCategories': 'すべてのカテゴリ',
  'pages.businessAppMarket.resetFilters': '絞り込みをリセット',
  'pages.businessAppMarket.resultCount': '{count} 件のアプリ',
  'pages.businessAppMarket.loadError': 'アプリマーケットを読み込めませんでした',
  'pages.businessAppMarket.loadErrorDescription':
    'アプリ情報を取得できません。しばらくしてから再試行してください。',
  'pages.businessAppMarket.retry': '再試行',
  'pages.businessAppMarket.empty': '公開中のアプリはありません',
  'pages.businessAppMarket.filteredEmpty': '条件に一致するアプリはありません',
  'pages.businessAppMarket.emptyDescription':
    '絞り込み条件を変更するか、後ほど新しいアプリをご確認ください。',
  'pages.businessAppMarket.details': '詳細を見る',
  'pages.businessAppMarket.detailTitle': 'アプリ詳細',
  'pages.businessAppMarket.description': 'アプリの説明',
  'pages.businessAppMarket.developer': '開発者',
  'pages.businessAppMarket.unknownDeveloper': '開発者情報なし',
  'pages.businessAppMarket.noDescription': '説明はありません',
  'pages.businessAppMarket.certification': '認証情報',
  'pages.businessAppMarket.official': '公式認証済み',
  'pages.businessAppMarket.unverified': '未認証',
  'pages.businessAppMarket.category': 'カテゴリ',
  'pages.businessAppMarket.uncategorized': '未分類',
  'pages.businessAppMarket.price': '料金',
  'pages.businessAppMarket.contactRequired': '運営に問い合わせ',
  'pages.businessAppMarket.contactReason':
    '販売価格が未設定、席数による料金設定、または利用開始方法が不明な場合は、運営にお問い合わせください。',
  'pages.businessAppMarket.freeActivate': '無料で利用開始',
  'pages.businessAppMarket.paidActivate': '購入して利用開始',
  'pages.businessAppMarket.open': 'アプリを開く',
  'pages.businessAppMarket.unavailableUrl':
    '利用可能なアクセス URL が設定されていません',
  'pages.businessAppMarket.installed': '利用開始済み',
  'pages.businessAppMarket.previewImages': 'アプリのプレビュー',
  'pages.businessAppMarket.previewAlt': '{name}のプレビュー {index}',
  'pages.businessAppMarket.noPreview': 'プレビュー画像はありません',
  'pages.businessAppMarket.close': '閉じる',
  'pages.businessAppMarket.missingApp': 'アプリが見つかりません',
  'pages.businessAppMarket.missingAppDescription':
    '現在のカタログ結果にアプリが見つかりません。アプリ名を検索して再試行してください。公開が終了している可能性もあります。',
  'pages.businessAppMarket.clearDetails': 'アプリ一覧に戻る',
  'pages.businessAppMarket.detailLoadError': 'アプリ詳細を読み込めませんでした',
  'pages.businessAppMarket.detailLoading': 'アプリ詳細を読み込み中',
  'pages.businessAppMarket.confirmFreeTitle': '無料利用の開始を確認',
  'pages.businessAppMarket.confirmPaidTitle': '購入を確認',
  'pages.businessAppMarket.confirmFreeDescription':
    '現在の企業で「{name}」の利用を開始します。',
  'pages.businessAppMarket.confirmPaidDescription':
    '現在の企業で「{name}」の購入注文を作成します。料金は {price} です。',
  'pages.businessAppMarket.confirm': '確認',
  'pages.businessAppMarket.cancel': 'キャンセル',
  'pages.businessAppMarket.activateSuccess': 'アプリの利用を開始しました',
  'pages.businessAppMarket.alreadyActive': 'アプリはすでに利用開始済みです',
  'pages.businessAppMarket.activateError':
    'アプリの利用を開始できませんでした。しばらくしてから再試行してください。',
  'pages.businessAppMarket.orderError':
    '注文を作成できませんでした。しばらくしてから再試行してください。',
  'pages.businessAppMarket.confirmationError':
    '利用開始の条件を確認できませんでした。更新して再試行してください。',
  'pages.businessAppMarket.contextChanged':
    '企業またはログイン状態が変更されました。更新してから操作してください。',
  'pages.businessAppMarket.sessionRequired':
    'ログインして企業を選択してください。',
};
